import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/app/[locale]/error.tsx");
